import { useState, useCallback } from 'react';
import { message } from 'antd';

import api from '@/services/api';

export default () => {
    const [ config, setConfig] = useState({});
    const [ configLoading, setConfigLoading] = useState(false);

    const getConfig = useCallback(() => {        

            setConfigLoading(true);        
            api.config({})
                .then(result => {
                    setConfigLoading(false);   
                    if (!result.success)
                        return console.log('config error', result);                            
                    setConfig(result.data);
                });      
    }, []);   

    return {
        configLoading,
        config,       
        getConfig,
    };
};
